import { IPOCANCEL_DATA, IPOCANCEL_ERROR_DATA, IPOCANCEL_HIDE_ERROR_DATA, IPOCANCEL_START_LOADER, IPOCANCEL_STOP_LOADER, } from "../interface/IpoCancel";
const initState = {
    data: {},
    loader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const IpoCancel = (state = initState, action) => {
    switch (action.type) {
        case IPOCANCEL_DATA:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case IPOCANCEL_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case IPOCANCEL_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        case IPOCANCEL_ERROR_DATA:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case IPOCANCEL_HIDE_ERROR_DATA:
            return Object.assign(Object.assign({}, state), { errorData: initState.errorData });
        default:
            return Object.assign({}, state);
    }
};
export default IpoCancel;
